<template>

    <div class="container">

        <StepGuide :stepCount="0"></StepGuide>

        <div class="body padding">

            <h1 class="teal padding textAlignCenter">Artwork Preview</h1>
            <div class="paddingTopSmall">
                <el-carousel :interval="114000" type="card" height="350px" arrow="always"
                             indicator-position="none" class="">
                    <el-carousel-item v-for="(thumb, index) in this.printJob.imageUrlThumb" :key="index">
                        <img class="centerContainer layout__height-250px layout__border__all-1px-grey" v-bind:src=thumb.thumbnailURL>
                        <p class="textAlignCenter padding">Page {{index + 1}}</p>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="textAlignCenter">
                {{printJob.printJobSpec.pageCount}} pages | {{printJob.printJobSpec.pageWidth}}mm x
                {{printJob.printJobSpec.pageHeight}}mm | {{printJob.printJobSpec.pageOrientation}}
            </div>
            <div class="padding">
                <el-button class="centerContainer redButton ravensworthButtons" v-on:click="next()">Confirm</el-button>
            </div>



        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue'

    export default {
        name: "start",
        components: {
            StepGuide,
        },
        props: {
            printJob: {},
        },
        data() {
            return {
                uploadPercentage: '',
                start: 0,
                end: 3,
                searchParams: {}
            }
        },
        created() {

            if (typeof this.printJob === 'undefined') {
                this.printJob = JSON.parse(window.sessionStorage.getItem('_printJob'))
                console.log(this.printJob)
            }
        },
        methods: {
            next() {
                Router.push({
                    name: 'wizardProducts',
                    params: {
                        printJob: this.printJob
                    }
                });
            },
            left() {
                if (this.start !== 0) {
                    this.start = this.start - 1
                    this.end = this.end - 1
                }

                console.log(this.start)
                console.log(this.end)

            },
            right() {
                console.log(this.end)
                console.log(this.printJob.imageUrlThumb.length)
                if (this.end <= this.printJob.imageUrlThumb.length) {
                    this.start = this.start + 1
                    this.end = this.end + 1
                }


                console.log(this.start)
                console.log(this.end)
            }
        }
    };
</script>